<template>
<div></div>
</template>

<script>
/* eslint-disable no-unused-vars */
import axios from "axios";

export default {
    props: ["tenantSlug", "experienceSlug"],
	mounted: function () {
        this.index();
    },
	methods: {
		index() {
			axios
				.get(
					"/system/public/experience/checker?tenantSlug=" +
						this.tenantSlug +
						"&experienceSlug=" +
						this.experienceSlug
				)
				.then((response) => {
                    if (response.data.dataMap.tenantType === "Exhibition") {
                        if (this.$store.getters.isLoggedIn && this.$store.state.principal.experienceId) {
							this.$router.push("/" + this.tenantSlug + "/" + this.experienceSlug + "/hall/" + response.data.slug);
						} else {
							this.$router.push("/" + this.tenantSlug + "/" + this.experienceSlug + "/login");
						}
                    } else {
						let query = this.$route.query;
						let link = "/" + this.tenantSlug + "/" + this.experienceSlug + "/room/" + response.data.slug;
						link += query.vuniteToken != null ? "?vuniteToken=" + query.vuniteToken : "";
                        this.$router.push(link);
                    }
				});
		},
	},
};
</script>